require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./unconsciousbias-faq.json") })
        }
      }, "path---unconsciousbias-faq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---unconsciousbias-faq!./.cache/json/unconsciousbias-faq.json
// module id = 1246
// module chunks = 231608221292675